import FuzzySearch from "fuzzy-search";
import {
  GetListParams,
  ProductRepositoryInterface,
  UpdateListParams,
  UpdateListResult,
} from "./product.repository.d";
import { BaseRepository } from "../Base/base.repository";
import { GetProductDto } from "./dto/get.dto";
import { ServerlessConfigure } from "../../config/serverless-configure";
import { UpdateProductDto } from "./dto/update.dto";

export class ProductRepository
  extends BaseRepository<GetProductDto>
  implements ProductRepositoryInterface
{
  constructor() {
    super(
      {
        baseURL: `${ServerlessConfigure.ApiEndpoint}`,
      },
      {
        hasSendToken: true,
      },
    );
  }

  async getList(params: GetListParams): Promise<GetProductDto[]> {
    const response = await this.apiRequest.getList({
      url: `/products`,
    });

    const searcher = new FuzzySearch(
      response.data.Items,
      [
        "name",
        "productKey",
        "productPrice",
        "productManufacturer",
        "homeNames",
        "tenantName",
      ],
      {
        caseSensitive: false,
      },
    );
    const result = searcher.search(params.keyword);
    return result;
  }

  async update(params: UpdateProductDto) {
    const response = await this.apiRequest.put<GetProductDto>({
      url: `/products/${params.productKey}`,
      data: {
        name: params.name ?? undefined,
        productPrice: params.productPrice ?? undefined,
        productWidth: params.productWidth ?? undefined,
        productHeight: params.productHeight ?? undefined,
        productDepth: params.productDepth ?? undefined,
        productCategories: params.productCategories ?? undefined,
        isActive: params.isActive ?? undefined,
        userId: params.userId,
      },
    });

    return response;
  }

  async updateList(params: UpdateListParams) {
    const response = await this.apiRequest.put<UpdateListResult>({
      url: `/products`,
      data: {
        userId: params.userId,
        items: params.items,
      },
    });

    return response;
  }
}
